export const reviewTimerDuration = 20000;
